<nav>
  <ul class="officer-area">
    <li tabindex="0" class="current-persona" *ngIf="currentPersona" (click)="removePersona()">
      <i class="fas fa-user-shield fa-lg"></i>
      <div>
        <div>Viewing as {{currentPersona.firstName}} {{currentPersona.lastName}}</div>
        <div class="stop-persona-switch">Click to Stop</div>
      </div>
    </li>

    <li tabindex="0">
      <i class="fas fa-exchange-alt fa-lg"></i><span>Switch Application</span><i class="fas fa-angle-down"></i>
      <ul>
        <li>
          <a class="kicbox-url" href="{{applicationUrls.kicboxUrl}}" target="_blank" tabindex="0"
            aria-label="kicbox for staff" (focus)="onSubMenuItemFocus($event)" (blur)="onSubMenuItemBlur($event)"
            (click)="onSubMenuItemClick($event)">kicbox for staff</a>
        </li>
        <li>
          <a class="carer-connect-url" href="{{applicationUrls.carerConnectUrl}}" target="_blank"
            aria-label="Carer Connect admin" tabindex="0" (focus)="onSubMenuItemFocus($event)"
            (blur)="onSubMenuItemBlur($event)" (click)="onSubMenuItemClick($event)">Carer Connect admin</a>
        </li>
        <li>
          <a class="our-child-url" href="{{applicationUrls.ourChildUrl}}" target="_blank" tabindex="0"
            aria-label="Our Child" (focus)="onSubMenuItemFocus($event)" (blur)="onSubMenuItemBlur($event)"
            (click)="onSubMenuItemClick($event)">Our Child</a>
        </li>
        <li>
          <a class="cspm-url" href="{{applicationUrls.practiceManualUrl}}" target="_blank" aria-label="Practice Manual"
            tabindex="0" (focus)="onSubMenuItemFocus($event)" (blur)="onSubMenuItemBlur($event)"
            (click)="onSubMenuItemClick($event)">Practice Manual</a>
        </li>
        <li>
          <a class="unify-url" href="{{applicationUrls.icmsUrl}}" target="_blank" tabindex="0" aria-label="Unify"
            (focus)="onSubMenuItemFocus($event)" (blur)="onSubMenuItemBlur($event)"
            (click)="onSubMenuItemClick($event)">Unify</a>
        </li>
        <li>
          <a class="intranet-url" href="{{applicationUrls.intranetUrl}}" target="_blank" tabindex="0"
            aria-label="Intranet" (focus)="onSubMenuItemFocus($event)" (blur)="onSubMenuItemBlur($event)"
            (click)="onSubMenuItemClick($event)">Intranet</a>
        </li>
      </ul>
    </li>
    <li tabindex="0">
      <i class="far fa-user-circle fa-lg"></i><span>{{fullName}}</span>
    </li>
  </ul>
</nav>